export const SKIP_COUNT_REFRESH = 'skipCountRefresh'
export const RESET_PAGE_NUMBER = 'resetPageNumber'
export const TRUE = 'true'
